import { Component, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResearchService } from 'src/app/pages/research/research.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  standalone: false,
  selector: 'app-create-research-project',
  templateUrl: './create-research-project.component.html',
})
export class CreateResearchProjectComponent {
  @ViewChild('createResearchProjectModal') modal!: TemplateRef<any>;

  form!: UntypedFormGroup;
  submitted = false;
  spinner = false;
  modalRef: any;

  constructor(
    private modalService: NgbModal,
    private fb: UntypedFormBuilder,
    private researchService: ResearchService,
    private authService: AuthService
  ) {}

  openModal(): void {
    this.submitted = false;
    this.spinner = false;
    this.form = this.fb.group({
      name: ['', Validators.required],
      description: ['']
    });
    this.modalRef = this.modalService.open(this.modal, { size: 'md', backdrop: 'static', keyboard: false });
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.form.invalid) return;
    this.spinner = true;
    this.researchService.createProject(this.form.value).subscribe({
      next: () => {
        this.spinner = false;
        this.modalRef.close();
        this.researchService.refreshProjects();
        this.authService.toastSuccessMessage('Project created successfully', 'Research Project');
      },
      error: (err: any) => {
        this.spinner = false;
        this.authService.toastErrorMessage(err?.message ?? err, 'Research Project');
      }
    });
  }

  closeModal(): void {
    this.modalRef?.close();
  }
}
